import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { requiredFileIf, requiredFiles } from '../../useValidateQuestionnaire';
import {
  InvestmentsStateValues,
  TPleaseEnterInformationBelowItem,
  TPleaseProvideDetailsOfAssetsSoldDuringYearItem,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  | keyof InvestmentsStateValues
  | keyof TPleaseProvideDetailsOfAssetsSoldDuringYearItem
  | keyof TPleaseEnterInformationBelowItem
>[] = [
  {
    name: 'didYouSellAnySecuritiesieStocksBondsMutualFundsCryptocurrencyOptionsEtcDuringTheFilingYear',
    label:
      'Did you sell any securities (ie stocks, bonds, mutual funds, cryptocurrency, options, etc) during the filing year?',
    subLabel: () => <p>Don't forget bitcoin, etc!</p>,
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'doYouHaveForm1099BAndorBrokerStatementsShowingTheTransction',
        label:
          'Do you have form 1099B and/or Broker Statements showing the transction?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'uploadForm1099BOrForeignEquivalent',
            label:
              'Upload Form 1099-B, foreign equivalent or summary of transactions report from professional trading program.',
            subLabel: () => (
              <p>
                If summary of transactions report from professional trading
                program, please provide in txt format
              </p>
            ),
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'didYouCarryOutSalesOfSecuritiesWithAnonUsFinancialInstitiution',
        label:
          'Did you carry out sales of securities with a (non-US) financial institiution?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseEnterInformationBelow',
            label: 'Please enter information below',
            type: 'fieldArray',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
            defaultDependency: {
              security: null,
              purchaseDate: null,
              saleDate: null,
              costBasis: null,
              currency: null,
              proceeds: null,
            },
            dependencies: [
              {
                name: 'security',
                label: 'Security',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'purchaseDate',
                label: 'Purchase Date',
                type: 'date',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Select Date',
              },
              {
                name: 'saleDate',
                label: 'Sale Date',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'costBasis',
                label: 'Cost Basis',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'currency',
                label: 'Currency',
                type: 'currency',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
              {
                name: 'proceeds',
                label: 'Proceeds',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'proceedscurrency',
                label: 'Currency',
                type: 'currency',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },
          {
            name: 'pleaseAlsoUploadTheYearEndBrokerageStatementForForeignieNonUsTransactions',
            label:
              'Please also upload the year-end brokerage statement for foreign (ie Non-US) transactions',
            type: 'upload',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
    ],
  },

  {
    name: 'doYouHaveInvestmentsInANonUsPooledInvestmentFundsEGMutualFundsUnitTrustsEtc',
    label:
      'Do you have investments in a Non-US pooled investment funds? E.g Mutual funds, Unit Trusts, etc.',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'isTheTotalValueOfTheInvestmentOver25000Or50000IfYouFileJointly',
        label:
          'Is the total value of the investment over $25,000 (or $50,000 if you file jointly)?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            name: 'didYouMakeAnySalesInTheFundsDuringYear',
            label: 'Did you make any sales in the fund(s) during {year}?',
            type: 'radio',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'KIsTheMinimumAmountForIndividualPficReporting50KIsTheMinimumAmountForSpousesFilingJointlyIfYourTotalNonUsMutualFundsAreBelowThatAmountAndYouDidNotSellAnyFundsThisYearYouDoNotNeedToFileForm8621',
            label:
              '$25K is the minimum amount for individual PFIC reporting. $50K is the minimum amount for spouses filing jointly. If your total non-US mutual funds are below that amount, and you did not sell any funds this year, you do not need to file form 8621.',
            type: 'text',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
        ],
      },
      {
        name: 'howManyNonUsMutualFundinvestmentAccountsDidYouHave',
        label: 'How many non-US mutual fund/investment accounts did you have?',
        type: 'text',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter',
      },
      {
        name: 'uploadAnnualStatementForLast3YearsInWhichTheFundWasHeldshowingYearEndBalance',
        label:
          'Upload annual statement for last 3 years in which the fund was held (showing year-end balance)',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
